<script lang="ts">
	export let title: string;
	export let subtitle = '';
	export let description = '';
</script>

<header class="mb-12 text-center">
	<h1 class="mb-4 text-4xl font-bold text-gray-900 dark:text-white">
		{title}
	</h1>

	{#if subtitle}
		<h2 class="mb-4 text-xl text-gray-600 dark:text-gray-300">
			{subtitle}
		</h2>
	{/if}

	{#if description}
		<p class="mx-auto max-w-3xl text-lg leading-relaxed text-gray-700 dark:text-gray-300">
			{description}
		</p>
	{/if}
</header>
